import Vue from 'vue';
import clientGroupTransformer from './../../transformers/clientGroup';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(clientGroupTransformer.fetch(errors));
};

export default (id, clientGroup) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/client_groups/${id}`, clientGroup)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client-group/update.js